import { __assign } from "tslib";
import * as React from 'react';
import { makeStyles, createStyles } from '../../styles';
import { SearchBox } from '../../SearchBox';
import { useComboboxContext } from '../Combobox.context';
export var useStyles = makeStyles(function () {
    return createStyles({
        root: {
            pointerEvents: 'none',
        },
        label: {
            transform: 'translate(40px, 9px) scale(0.875)',
        },
        labelShrink: {
            opacity: 0,
        },
        input: {
            borderRadius: '1px 1px 0px 0px',
        },
    });
});
export var Search = function () {
    var _a = useComboboxContext(), searchInputRef = _a.searchInputRef, handleOnSearch = _a.handleOnSearch, handleSearchOnKeyDown = _a.handleSearchOnKeyDown, setListboxHasFocus = _a.setListboxHasFocus, searchString = _a.searchString, comboboxProps = _a.comboboxProps;
    var id = comboboxProps.id, strings = comboboxProps.strings, autoComplete = comboboxProps.autoComplete, searchProps = comboboxProps.SearchProps;
    var searchLabel = strings.searchLabel;
    var classes = useStyles();
    return (React.createElement(SearchBox, __assign({ inputRef: searchInputRef, inputId: "".concat(id, "-search-box"), label: searchLabel, onChange: handleOnSearch, onKeyDown: handleSearchOnKeyDown, onEscape: handleSearchOnKeyDown, InputProps: {
            classes: {
                root: classes.input,
            },
        }, InputLabelProps: {
            classes: {
                root: classes.label,
                shrink: classes.labelShrink,
            },
            shrink: Boolean(searchString === null || searchString === void 0 ? void 0 : searchString.length),
        }, TextFieldProps: {
            autoComplete: autoComplete,
            autoFocus: true,
            onFocus: function () { return setListboxHasFocus(false); },
        }, hideIconOnFocus: false, value: searchString }, searchProps)));
};
export default Search;
//# sourceMappingURL=Combobox.Search.js.map